module.exports = __webpack_public_path__ + "img/ruble.c332b96d.svg";